<div class="acc-entrepreneurs-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="accEntrepreneurs()"></grid-content>
</div>